import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "../components/loader/loader";
import Layout from "../layout.jsx";

import ProtectedRoute from "./ProtectedRoute";
import RootRedirect from "./rootRedirect";

import { publicRoutes, protectedRoutes } from "./routeConfig";

const Approutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Root */}
        <Route path="/" element={<RootRedirect />} />

        {/* Public Routes */}
        {publicRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}

        {/* Protected Routes */}
        {protectedRoutes.map(({ path, component: Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute>
                <Layout>
                  <Component />
                </Layout>
              </ProtectedRoute>
            }
          />
        ))}
      </Routes>
    </Suspense>
  );
};

export default Approutes;
